import React from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";

import Image from '../../../../../containers/assets/pf10.png';

const RoaStep3 = () => (
  <BannerLayout
    section="FEEDBACK"
    subSection="ROA"
    hideAlert={true}
    subTitle="Return on Investments"
    paragraph1={(
      <Fragment>
        Some companies have sizable assets and therefore it can be challenging to generate the needed income
        to hit a decent return on their assets. Apple is not one of those companies.
      </Fragment>
    )}
    paragraph2={(
      <Fragment>
        For example, Apple's average total assets in $337 billion dollars. To generate just 1% return on assets,
        Apple would need to generate $3.52 billion dollars in net profits. The company, however, generated $94
        billion dollars, which based on their average total assets is a 28% ROA.
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default RoaStep3;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/roa/step3.js